const routes = {
  root: "/",
  auth: {
    root: "/auth",
    login: "/auth/login",
    temp: "/auth/cognito/callback",
    logout: "/auth/logout",
    callback: "/auth/callback",
  },
  general: {
    information: "/general/information",
    dashboardsOverview: "/general/dashboards",
  },
  home: "/",
  dashboards: "/dashboards",
  dashboard: "/:dashboard",
  landWarnings: "/:dashboard/land-warnings",
  maritimeWarnings: "/:dashboard/maritime-warnings",
  users: "/:dashboard/users",
  page: "/:dashboard/:page/:subPage?",
  admin: {
    home: "/admin",
    dashboard: "/admin/dashboard/:dashboard",
    dashboard_page: "page/:page",
    dashboard_settings: "settings",
    dashboard_pages_overview: "pages",
    organisations: "/admin/organisations",
    organistation_details: "/admin/organisations/:organisationId",
    extranets: "/admin/extranets",
    extranet_details: "/admin/extranets/:extranetId",
  },
};
export default routes;
